import React, { Component } from 'react'
import i18n from 'i18next'
import Button from '../../UniformComponents/Button'

export default class PageSwitchTab extends Component {
    constructor(props) {
        super(props)
        this.availableTabs = this.getAvailableTabs()
    }

    goToTab = (tabName) => {
        const { history } = this.props
        if (tabName) history.push(tabName)
    }

    getAvailableTabs = () => {
        const { props } = this
        const { tabOptions } = props
        let availableTabs = []
        switch (tabOptions.name) {
            case 'manageEvents':
                availableTabs = tabOptions.tabs?.filter((tab) => {
                    if (tab.value === 'divisions' && !props.hasMultiDivision) return false
                    return tab.checkPermission(props.userRole)
                })
                break
            case 'questions':
                availableTabs = tabOptions.tabs?.filter(
                    (tab) => tab.checkPermission(props.userRole),
                )
                break
            case 'templates':
                availableTabs = tabOptions.tabs?.filter(
                    (tab) => tab.checkPermission(props.userRole),
                )
            default:
                break
        }
        return availableTabs
    }

    isTabActive = (tab) => {
        const { location } = this.props
        return location.pathname.startsWith(tab.path)
    }

    render() {
        const { tabOptions } = this.props
        return (
            <div className="switch-button">
                <ul className="tabs">
                    {this.availableTabs.length > 1
                    && this.availableTabs.map((tab) => (
                        <li key={tab.key}>
                            <Button
                                type="button"
                                onClick={() => this.goToTab(tab.path)}
                                cssClass={`${tabOptions.name === 'manageEvents' ? 'compact' : ''} ${this.isTabActive(tab) ? 'active' : ''}`}
                            >
                                <i className={`fa-regular ${tab.icon ?? 'fa-square-poll-vertical'}`} />
                                {i18n.t(tab.value)}
                            </Button>
                        </li>
                    ))}
                </ul>
            </div>
        )
    }
}
